import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import { useAuth } from '../contexts/AuthContext';
import { getAdicionais } from '../services/api';

const API_URL = process.env.REACT_APP_API_URL || '';
const RETIRAR = ['Alface','Tomate','Cebola','Picles','Maionese','Mostarda','Ketchup','Molho especial'];

const isCombo = (ad) => ad.nome && ad.nome.toLowerCase().startsWith('combo:');

function Personalizacao({ item, onChange, adicionaisDisponiveis, splitItem, mergeIguais }) {
  const [aberto, setAberto] = useState(false);
  const [qtdCombo, setQtdCombo] = useState(item.qty);
  useEffect(() => { setQtdCombo(item.qty); }, [item.qty]);
  const adicionais = item.adicionais || [];
  const remover    = item.remover    || [];
  const obs        = item.observacao || '';
  const temAlgo    = adicionais.length > 0 || remover.length > 0 || obs;

  const totalAdicionais = adicionais.reduce((s, a) => s + Number(a.preco) * (a.quantidade || 1), 0);

  const combosDisponiveis = adicionaisDisponiveis.filter(isCombo);
  const extrasDisponiveis = adicionaisDisponiveis.filter(a => !isCombo(a));

  const comboSelecionado = adicionais.find(a => {
    const ad = adicionaisDisponiveis.find(x => x.id === a.id);
    return ad && isCombo(ad);
  });

  const getQtdAdicional = (id) => {
    const ad = adicionais.find(a => a.id === id);
    return ad ? (ad.quantidade || 1) : 0;
  };

  const escolherCombo = async (combo) => {
    const isToggle = comboSelecionado && comboSelecionado.id === combo.id;
    // monta novos adicionais (removendo combo anterior)
    let nova = adicionais.filter(a => {
      const ad = adicionaisDisponiveis.find(x => x.id === a.id);
      return !(ad && isCombo(ad));
    });
    if (!isToggle) {
      nova = [...nova, { id: combo.id, nome: combo.nome, preco: combo.preco, emoji: combo.emoji, quantidade: 1 }];
    }
    // se item.qty > 1 e cliente escolheu qtdCombo < qty => split
    if (item.qty > 1 && qtdCombo < item.qty && !isToggle) {
      await splitItem(item._uid, qtdCombo, { adicionais: nova });
      if (mergeIguais) mergeIguais();
    } else {
      onChange({ adicionais: nova });
      if (isToggle && mergeIguais) setTimeout(() => mergeIguais(), 10);
    }
  };

  const mudarAdicional = (adicional, delta) => {
    const atual = adicionais.find(a => a.id === adicional.id);
    let nova;
    if (!atual && delta > 0) {
      nova = [...adicionais, { id: adicional.id, nome: adicional.nome, preco: adicional.preco, emoji: adicional.emoji, quantidade: 1 }];
    } else if (atual) {
      const novaQtd = (atual.quantidade || 1) + delta;
      if (novaQtd <= 0) {
        nova = adicionais.filter(a => a.id !== adicional.id);
      } else {
        nova = adicionais.map(a => a.id === adicional.id ? { ...a, quantidade: novaQtd } : a);
      }
    } else {
      return;
    }
    onChange({ adicionais: nova });
  };

  const toggleRemover = (op) => {
    const novo = remover.includes(op) ? remover.filter(x => x !== op) : [...remover, op];
    onChange({ remover: novo });
  };

  return (
    <div style={{ marginTop: 8 }}>
      <button onClick={() => setAberto(p => !p)} style={{
        background: aberto
          ? 'var(--bg4)'
          : temAlgo
            ? 'linear-gradient(135deg, #ff6b00, #ff3d00)'
            : 'linear-gradient(135deg, #ff8c00, #ff4500)',
        border: aberto ? '1px solid var(--border)' : 'none',
        color: aberto ? 'var(--text2)' : '#fff',
        padding: aberto ? '8px 14px' : '12px 16px',
        borderRadius: 12,
        cursor: 'pointer',
        fontSize: aberto ? 12 : 13,
        fontFamily: 'Nunito,sans-serif',
        fontWeight: 800,
        width: '100%',
        marginTop: 4,
        boxShadow: aberto ? 'none' : '0 4px 14px rgba(255,80,0,.45)',
        animation: aberto ? 'none' : 'pulsePersonalizar 2s ease-in-out infinite',
        transition: 'all .2s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8
      }}>
        {aberto ? (
          <span style={{ width: '100%', textAlign: 'center' }}>✕ Fechar personalização</span>
        ) : (
          <>
            <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.2 }}>
              <span style={{ fontSize: 14, fontWeight: 900, textTransform: 'uppercase', letterSpacing: .3 }}>
                ✨ {temAlgo ? 'Personalizado' : 'Personalizar lanche'}
                {temAlgo && totalAdicionais > 0 ? ` (+R$ ${totalAdicionais.toFixed(2).replace('.', ',')})` : ''}
              </span>
              <span style={{ fontSize: 10.5, fontWeight: 600, opacity: .95 }}>
                🍔🍟 Combo, bacon, queijo extra e mais...
              </span>
            </span>
            <span style={{ fontSize: 18, fontWeight: 900 }}>›</span>
          </>
        )}
      </button>
      <style>{`
        @keyframes pulsePersonalizar {
          0%, 100% { box-shadow: 0 4px 14px rgba(255,80,0,.45); transform: scale(1); }
          50% { box-shadow: 0 6px 22px rgba(255,80,0,.7); transform: scale(1.015); }
        }
      `}</style>

      {aberto && (
        <div style={{ marginTop: 10, background: 'var(--bg4)', border: '1px solid var(--border)', borderRadius: 10, padding: 12 }}>

          {/* COMBO em destaque */}
          {combosDisponiveis.length > 0 && (
            <div style={{
              marginBottom: 14,
              background: 'linear-gradient(135deg, rgba(255,140,0,.12), rgba(255,80,0,.06))',
              border: '1px solid var(--orange)',
              borderRadius: 10,
              padding: 12
            }}>
              <div style={{ fontSize: 12, fontWeight: 800, color: 'var(--orange)', marginBottom: 4, textTransform: 'uppercase' }}>
                🍟🥤 Transformar em combo (+R$ 18,00)
              </div>
              <div style={{ fontSize: 11, color: 'var(--text2)', marginBottom: 10 }}>
                Batata individual + Refrigerante 350ml — escolha o sabor:
              </div>

              {item.qty > 1 && (
                <div style={{ marginBottom: 10, padding: 8, background: 'var(--bg3)', borderRadius: 8, border: '1px dashed var(--orange)' }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--orange)', marginBottom: 6 }}>
                    Aplicar combo em quantas das {item.qty} unidades?
                  </div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    {Array.from({ length: item.qty }, (_, i) => i + 1).map(n => (
                      <button key={n} onClick={() => setQtdCombo(n)} style={{
                        padding: '6px 12px',
                        background: qtdCombo === n ? 'var(--orange)' : 'var(--bg4)',
                        border: `1px solid ${qtdCombo === n ? 'var(--orange)' : 'var(--border)'}`,
                        color: qtdCombo === n ? '#fff' : 'var(--text)',
                        borderRadius: 6, cursor: 'pointer',
                        fontWeight: 700, fontSize: 13, minWidth: 36
                      }}>{n}</button>
                    ))}
                  </div>
                </div>
              )}

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 6 }}>
                {combosDisponiveis.map(combo => {
                  const ativo = comboSelecionado && comboSelecionado.id === combo.id;
                  const saborNome = combo.nome.replace(/^Combo:\s*Batata\s*\+\s*/i, '').replace(/\s*350ml\s*$/i, '');
                  return (
                    <button key={combo.id} onClick={() => escolherCombo(combo)} style={{
                      display: 'flex', alignItems: 'center', gap: 6,
                      padding: '8px 10px',
                      background: ativo ? 'var(--orange)' : 'var(--bg3)',
                      border: `1px solid ${ativo ? 'var(--orange)' : 'var(--border)'}`,
                      color: ativo ? '#fff' : 'var(--text)',
                      borderRadius: 8, cursor: 'pointer',
                      fontSize: 12, fontWeight: 700, fontFamily: 'Nunito,sans-serif',
                      textAlign: 'left'
                    }}>
                      <span style={{ fontSize: 18 }}>{combo.emoji || '🥤'}</span>
                      <span style={{ flex: 1, lineHeight: 1.2 }}>{saborNome}</span>
                      {ativo && <span style={{ fontSize: 14 }}>✓</span>}
                    </button>
                  );
                })}
              </div>
            </div>
          )}

          {/* Adicionais com preço */}
          {extrasDisponiveis.length > 0 && (
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 800, color: '#2ea82e', marginBottom: 8, textTransform: 'uppercase' }}>➕ Adicionar (acréscimo)</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {extrasDisponiveis.map(ad => {
                  const qtd = getQtdAdicional(ad.id);
                  const ativo = qtd > 0;
                  return (
                    <div key={ad.id} style={{
                      display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px',
                      background: ativo ? 'rgba(46,168,46,.12)' : 'var(--bg3)',
                      border: `1px solid ${ativo ? '#2ea82e' : 'var(--border)'}`,
                      borderRadius: 8
                    }}>
                      <span style={{ fontSize: 18 }}>{ad.emoji || '➕'}</span>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13, fontWeight: 700 }}>{ad.nome}</div>
                        <div style={{ fontSize: 11, color: '#2ea82e', fontWeight: 700 }}>+R$ {Number(ad.preco).toFixed(2).replace('.', ',')}</div>
                      </div>
                      {qtd === 0 ? (
                        <button onClick={() => mudarAdicional(ad, 1)} style={{
                          background: '#2ea82e', border: 'none', color: '#fff',
                          padding: '6px 14px', borderRadius: 6, cursor: 'pointer',
                          fontSize: 12, fontWeight: 800, fontFamily: 'Nunito,sans-serif'
                        }}>+ Adicionar</button>
                      ) : (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <button onClick={() => mudarAdicional(ad, -1)} style={{
                            background: 'var(--bg4)', border: '1px solid var(--border)', color: 'var(--text)',
                            width: 26, height: 26, borderRadius: 6, cursor: 'pointer', fontSize: 14, fontWeight: 700
                          }}>−</button>
                          <span style={{ fontWeight: 800, minWidth: 18, textAlign: 'center', color: '#2ea82e' }}>{qtd}</span>
                          <button onClick={() => mudarAdicional(ad, 1)} style={{
                            background: '#2ea82e', border: 'none', color: '#fff',
                            width: 26, height: 26, borderRadius: 6, cursor: 'pointer', fontSize: 14, fontWeight: 700
                          }}>+</button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Retirar (sem custo) */}
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 11, fontWeight: 800, color: 'var(--red)', marginBottom: 6, textTransform: 'uppercase' }}>➖ Retirar</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
              {RETIRAR.map(op => (
                <button key={op} onClick={() => toggleRemover(op)} style={{
                  background: remover.includes(op) ? 'rgba(230,48,48,.2)' : 'var(--bg3)',
                  border: `1px solid ${remover.includes(op) ? 'var(--red)' : 'var(--border)'}`,
                  color: remover.includes(op) ? 'var(--red)' : 'var(--text2)',
                  padding: '4px 10px', borderRadius: 20, cursor: 'pointer',
                  fontSize: 11, fontFamily: 'Nunito,sans-serif', fontWeight: 700
                }}>{remover.includes(op) ? '✓ Sem ' : '− '}{op}</button>
              ))}
            </div>
          </div>

          {/* Observação */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 800, color: 'var(--orange)', marginBottom: 6, textTransform: 'uppercase' }}>💬 Observação</div>
            <input className="input-field" placeholder="Ex: bem passado, pão sem glúten..."
              value={obs} onChange={e => onChange({ observacao: e.target.value })}
              style={{ fontSize: 12, padding: '8px 12px' }} />
          </div>
        </div>
      )}

      {/* Preview fora do painel */}
      {!aberto && temAlgo && (
        <div style={{ marginTop: 6, fontSize: 11, lineHeight: 1.8 }}>
          {adicionais.length > 0 && (
            <div style={{ color: '#2ea82e' }}>
              ➕ {adicionais.map(a => `${a.quantidade || 1}x ${a.nome}`).join(', ')}
              {totalAdicionais > 0 && <span style={{ fontWeight: 800 }}> (+R$ {totalAdicionais.toFixed(2).replace('.', ',')})</span>}
            </div>
          )}
          {remover.length > 0 && <div style={{ color: 'var(--red)' }}>➖ Sem: {remover.join(', ')}</div>}
          {obs && <div style={{ color: 'var(--orange)' }}>💬 {obs}</div>}
        </div>
      )}
    </div>
  );
}

export default function Carrinho() {
  const { cart, removeItem, changeQty, updateItemOpts, splitItem, mergeIguais, subtotal, total, totalItems, precoItem } = useCart();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [adicionaisDisponiveis, setAdicionaisDisponiveis] = useState([]);

  useEffect(() => {
    getAdicionais().then(r => setAdicionaisDisponiveis(r.data)).catch(() => {});
  }, []);

  if (!cart.length) return (
    <div style={{ padding: 16 }}>
      <h2>🛒 Carrinho</h2>
      <div className="empty-state">
        <div className="icon">🛒</div>
        <h3>Carrinho vazio</h3>
        <p>Adicione produtos e peça já!</p>
        <button className="btn-primary" style={{ marginTop: 16, width: 'auto', padding: '12px 24px' }} onClick={() => navigate('/cardapio')}>Ver cardápio</button>
      </div>
    </div>
  );

  return (
    <div style={{ padding: 16 }}>
      <h2>🛒 Meu Pedido ({totalItems} {totalItems === 1 ? 'item' : 'itens'})</h2>

      {cart.map(item => (
        <div key={item.id} style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 12, padding: 12, marginBottom: 10 }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
            <div style={{ width: 52, height: 52, borderRadius: 8, background: 'var(--bg4)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, overflow: 'hidden', flexShrink: 0 }}>
              {item.imagem_url ? <img src={`${API_URL}${item.imagem_url}`} alt={item.nome} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : item.emoji}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 14 }}>{item.nome}</div>
              <div style={{ color: 'var(--orange)', fontWeight: 800, fontSize: 13, marginTop: 2 }}>
                R$ {precoItem(item).toFixed(2).replace('.', ',')}
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
              <button onClick={() => changeQty(item._uid, -1)} style={{ background: 'var(--bg4)', border: '1px solid var(--border)', color: 'var(--text)', width: 28, height: 28, borderRadius: 6, cursor: 'pointer', fontSize: 16 }}>−</button>
              <span style={{ fontWeight: 700, minWidth: 20, textAlign: 'center' }}>{item.qty}</span>
              <button onClick={() => changeQty(item._uid, 1)} style={{ background: 'var(--bg4)', border: '1px solid var(--border)', color: 'var(--text)', width: 28, height: 28, borderRadius: 6, cursor: 'pointer', fontSize: 16 }}>+</button>
              <button onClick={() => removeItem(item._uid)} style={{ background: 'none', border: 'none', color: 'var(--text3)', cursor: 'pointer', fontSize: 18, padding: 4 }}>🗑</button>
            </div>
          </div>

          <Personalizacao item={item} onChange={opts => updateItemOpts(item._uid, opts)} adicionaisDisponiveis={adicionaisDisponiveis} splitItem={splitItem} mergeIguais={mergeIguais} />
        </div>
      ))}

      <div style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 10, padding: 16, marginTop: 4 }}>
        {[['Subtotal', `R$ ${subtotal.toFixed(2).replace('.', ',')}`], ['Taxa de entrega', 'calculada no checkout']].map(([k, v]) => (
          <div key={k} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: 'var(--text2)', marginBottom: 6 }}>
            <span>{k}</span><span>{v}</span>
          </div>
        ))}
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 18, fontWeight: 800, borderTop: '1px solid var(--border)', paddingTop: 10, marginTop: 6 }}>
          <span>Total</span>
          <span style={{ color: 'var(--orange)' }}>R$ {total.toFixed(2).replace('.', ',')}</span>
        </div>
        <div style={{ fontSize: 12, color: 'var(--orange)', marginTop: 6 }}>⭐ Você ganhará +{Math.floor(total)} pontos</div>
      </div>

      <button className="btn-primary" style={{ marginTop: 12 }} onClick={() => user ? navigate('/checkout') : navigate('/login')}>
        💳 {user ? 'Continuar para pagamento' : 'Entrar para finalizar'}
      </button>
    </div>
  );
}
